var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"视频","visible":_vm.dialogVisible,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('YPlay',{ref:"YPlay",attrs:{"videoUrl":_vm.videoUrl,"controls":"","width":"100%","height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }